import Storage from '../components/Storage';
import { __IDEVENT_SETTED__ } from '../idEvent';

export const __IDEVENT_FORCED__ = __IDEVENT_SETTED__;//Defecto 0,Si aca pongo el id del evento entonces no lo toma por parámetro
export const __IS_TEST__ = false;
export const __ISDDEVELPMENT__ = false;
export const __USELOCAHOSTAPI__ = false;
export const __DOMAIN__ = __ISDDEVELPMENT__ == false ? '.kingconf.com' : 'localhost';
export const __APIURLVIRTUALEXPO__ = __USELOCAHOSTAPI__ == true ? 'http://localhost:54652/' : 'https://virtualapi.kingconf.com/';
export const __EXHIBITOR_PROFILE__ = "exhibitor";
export const __BR_ROUNDS_GROUP_ONE__ = "attendee" //hostedBuyer | exhibitor | attendee
export const __BR_ROUNDS_GROUP_TWO__ = "exhibitor";
export const __ATTENDEES_ALIAS__ = "Participante/Attendee"; //Esto es el badge que se muestra en la lista de networking
export const __EXHIBITOR_ALIAS__ = "Docente/Speaker";//Esto es el badge que se muestra en la lista de networking
export const __HOSTEDBUYER_ALIAS__ = "CIPDH-UNESCO";//Esto es el badge que se muestra en la lista de networking
export const __SPEAKER_ALIAS__ = "Personaje";//Esto es el badge que se muestra en la lista de networking
export const __SHOW_SPLASH_VIDEO__ = false;

//CONFIGURATION CONSTS START
/*          LOGIN           */
export const __LOGIN_VIDEO_BACKGROUND_URL__ = "";
export const __HORIZONTAL_LOGIN__ = false;
export const __LOGIN_TITLE_ENABLED__ = false;
export const __PASSWORD_RESET_ENABLED__ = false;
export const __LOGIN_SCREEN_POSITION__ = "left";
export const __REGISTRATION_ENABLED__ = false;
export const __EMAIL_ONLY_AUTHENTICATION__ = false;
//CONFIGURATION CONSTS END

export const __VALID_MAILS_FOR_CERTIFICATES__ = "*" // USAR "" para no mostrar la funcion o * para habilitar todos

export const __APIKCURL__ = __IS_TEST__ ? 'https://kcapitest.azurewebsites.net/api/' : 'https://apiv2.kingconf.com/api/';
export const __APIKCURL_V3__ = (__IS_TEST__ ? 'https://kcapitest.azurewebsites.net/v3.0/events/' : 'https://apiv2.kingconf.com/v3.0/events/') + Storage.getIdEvent() + '/';
export const __LIVEAPIURL__ = 'https://liveapi.kingconf.com/api/';
export const __APIPACKAGEURL__ = (__IS_TEST__ ? "https://kcapitest.azurewebsites.net/api/eventpackage/" : "https://apiv2.kingconf.com/api/eventpackage/") + Storage.getIdEvent();
export const __API_TRIVIA_URL__ = __APIKCURL_V3__ + 'challenges/';
export const __API_SPONSORS_URL__ = __APIKCURL__ + "sponsors/" + Storage.getIdEvent()
// platform=businessrounds: el backend publica como endDate el fin de la ventana de acceso
// de rondas (BR_ACCESS_END_DATE) si está configurada — el kick por heartbeat la respeta.
export const __API_VIRTUAL_BASIC_INFO__ = __APIKCURL_V3__ + "virtualBasicInfo?platform=businessrounds";
export const __API_EVENT_TRANSLATIONS__ = __APIKCURL_V3__ + "Translation/eventtranslation";
export const __API_ROOMS_URL__ = __APIKCURL_V3__ + "rooms";
export const __API_ROOMS_BY_USER__ = `${__APIKCURL_V3__}roomsByRegistration/`;
export const __API_CHECK_ROOM_PERMISSION__ = `${__APIKCURL_V3__}checkRoomAccessByRegistration/`;
export const __IMAGEHANDLER_URL__ = "https://be.kingconf.com/Handlers/ImageHandler.ashx?AcImageId=";

export const __API_SESSIONS_CONTENT_URL__ = __APIKCURL__ + "sessionContent/";
export const __API_SPEAKERS_URL__ = __APIKCURL__ + "speakers/" + Storage.getIdEvent();
export const __API_ATTENDEES_URL__ = __APIKCURL_V3__ + "/attendees/";

//BUSSINES ROUNDS
export const __BR_REQUEST_MEETING__ = __APIKCURL_V3__ + "requestBusinessRoundMeeting/";
export const __BR_DECLINE_MEETING__ = __APIKCURL_V3__ + "declineBusinessRoundMeeting/";
export const __BR_ACCEPT_MEETING__ = __APIKCURL_V3__ + "acceptBusinessRoundMeeting/";
export const __BR_RESPONSE_MEETING__ = __APIKCURL_V3__ + "responseBusinessRoundMeeting/";
export const __BR_MY_MEETINGS_SLOTS__ = __APIKCURL_V3__ + "businessRoundMyMeetingSlots/";
export const __BR_AVAILABLE_MEETINGS_SLOTS__ = __APIKCURL_V3__ + "businessRoundAvailableMeetingSlots/"; //AGENDA CONJUNTA CON UN REQUESTEE
export const __BR_SLOT_BLOCK__ = __APIKCURL_V3__ + "blockBusinessRoundMeeting/";
export const __BR_SLOT_UNBLOCK__ = __APIKCURL_V3__ + "unblockBusinessRoundMeeting/";
export const __BR_ATTENDEES_PAGINATED__ = __APIKCURL_V3__ + "attendees/attendeesPaginated";
// Catálogo de campos extra del formulario de expositor (solo VisibleInApp).
// Array vacío si el evento no tiene formulario. El id (GUID) de cada campo es
// la llave: matchea con exhibitor.extraFields[].id de cada asistente y con el
// par exhibitorFieldId/exhibitorFieldValue de attendeesPaginated.
export const __BR_EXHIBITOR_EXTRAFIELDS_SCHEMA__ = __APIKCURL_V3__ + "exhibitors/extraFieldsSchema";
// Favoritos del usuario. El idRegistration sale del token, nunca va en el body.
// type: 0 expositor · 1 sesión · 2 speaker · 3 sponsor.
export const __BR_FAVORITES__ = __APIKCURL_V3__ + "favorites";
// Mi propio registro. attendeesPaginated NUNCA devuelve al usuario que llama,
// así que este es el único camino para armar "Mi perfil". Devuelve los mismos
// campos que /authenticate (menos el token) y solo necesita el token, así que
// también funciona embebido, donde el módulo nunca pasa por el login.
export const __BR_ME__ = __APIKCURL_V3__ + "attendees/me";
// Ficha pública de los expositores del evento: about (con traducciones),
// website, redes, stand, dirección, pictureId. Es la fuente real de la info de
// empresa — se cruza por id con exhibitor.idExhibitor de cada asistente.
export const __BR_EXHIBITORS__ = __APIKCURL__ + "exhibitors/" + Storage.getIdEvent();
// Subida de la foto de perfil. El endpoint identifica al usuario por los
// headers registrationCode + idEvent (no por el token) y devuelve el pictureId
// nuevo. Mismo que usa frontendcongress en UserProfile.
export const __BR_ATTENDEE_IMAGE_UPLOAD__ = __APIKCURL__ + "AttendeeImageUpload/";
export const __BR_CONFIGURATION__ = __APIKCURL_V3__ + 'businessRoundConfiguration?utcTimeStamp=2012-01-01'
export const __BR_CALENDAR_BLOCK__ = __APIKCURL_V3__ + "blockMeetings/";
export const __BR_CALENDAR_UNBLOCK__ = __APIKCURL_V3__ + "unblockMeetings/";
export const __BR_EXPORT_CALENDAR_PDF__ = __APIKCURL_V3__ + "exportCalendarToPdf";

export const __BR_MEETING__ = __APIKCURL_V3__ + "businessRoundMeeting/"; //TODAS LAS MEETINGS DE TODOS LOS PARTICIPANTES
export const __API_VIDEO_URL__ = __APIKCURL__ + '/videos/' + Storage.getIdEvent();
export const __TWILIO_VIDEO_TOKEN__ = __APIURLVIRTUALEXPO__ + "createTwilioToken/";
export const __API_LEADERBOARD_URL__ = __APIKCURL_V3__ + "leaderBoard/";
export const __API_LEADERBOARDBRIEF_URL__ = __APIKCURL_V3__ + "/leaderBoardBrief/";
export const __API_REDEEM_POINTS_URL__ = __APIKCURL_V3__ + "/RedeemPointsUniferia/";
export const __API_ATTENDEES_FORGOTPASSWORD__ = __APIKCURL_V3__ + "attendees/forgotPassword?email=";
export const __API_PERSONAL_PACKAGE__ = __APIKCURL_V3__ + "attendees/personalPackage";
export const __API_MY_MESSAGES__ = __APIKCURL_V3__ + "attendees/mymessages/";
export const __API_CONTACTS__ = __APIKCURL_V3__ + "contacts";
export const __API_EXHIBITOR_REPRESENTATIVE__ = __APIKCURL_V3__ + "exhibitor/";
export const __API_LOGS__ = __APIKCURL_V3__ + "/log";
export const __LIVEAPI_ACTIVITIES_RATE__ = __LIVEAPIURL__ + 'ActivityRate/' + Storage.getIdEvent();
